module.exports = __webpack_public_path__ + "static/rocks-zoom-702aeec8eb864989feab7053fef41ac0.jpg";